import { ReactNode } from "react";

type PressQuote = {
    publication: string;
    logoUrl: string;
    logoIntrinsicWidth: number;
    logoIntrinsicHeight: number;
    logoMobileHeight: number;
    logoDesktopHeight: number;
    quote: ReactNode;
    articleTitle: string;
};

export const PRESS_QUOTES: PressQuote[] = [
    {
        publication: "USA Today",
        logoUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790610027/new_design/usa-today-logo_1_1_do7frs.webp",
        logoIntrinsicWidth: 124,
        logoIntrinsicHeight: 48,
        logoMobileHeight: 40,
        logoDesktopHeight: 48,
        quote: <>Women don’t need more complexity — <br className="max-md:hidden" />they need hormone care that works.</>,
        articleTitle: "Inner Balance Brings New Approach to Women’s Hormone Health and Skin Care",
    },
    {
        publication: "LA Weekly",
        logoUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790591809/new_design/LA_Weekly_logo.svg_1_f7d7co.webp",
        logoIntrinsicWidth: 130,
        logoIntrinsicHeight: 33,
        logoMobileHeight: 40,
        logoDesktopHeight: 48,
        quote: <>Women don’t need more serums. They need solutions rooted in science. Solutions that understand how their hormones affect their skin.</>,
        articleTitle: "Inner Balance Launches the First Hormone-Informed Anti-Aging Cream with a Prescription DHT Blocker for Women",
    },
    {
        publication: "Womanly",
        logoUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790591810/new_design/womanly-magazine.1200x0_1_y7wzj0.webp",
        logoIntrinsicWidth: 196,
        logoIntrinsicHeight: 48,
        logoMobileHeight: 40,
        logoDesktopHeight: 48,
        quote: <>We have self-driving cars on the streets now—there’s no reason women should have to accept suffering as part of their health journey.</>,
        articleTitle: "Revolutionizing Hormonal Health: A Conversation with the Founder and CEO of Inner Balance",
    },
    {
        publication: "Muscle & Fitness",
        logoUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790591810/new_design/108-1080204_muscle-fitness-logo_1_wajzl0.webp",
        logoIntrinsicWidth: 144,
        logoIntrinsicHeight: 48,
        logoMobileHeight: 40,
        logoDesktopHeight: 48,
        quote: <>Women deserve a hormone therapy that supports all of their systems—mood, metabolism, sleep, libido, brain, bones—not just vaginal tissue...</>,
        articleTitle: "Oestra™ by Inner Balance is Redefining Hormone Therapy — And New Data Shows It’s Working",
    },
    {
        publication: "HuffMag",
        logoUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790591809/new_design/HML1_j8vsvr.webp",
        logoIntrinsicWidth: 260,
        logoIntrinsicHeight: 48,
        logoMobileHeight: 32,
        logoDesktopHeight: 40,
        quote: <>At Inner Balance, we don’t hand women a prescription and disappear. We walk with them. Hormone therapy is a journey—and no woman should go through it alone.</>,
        articleTitle: "Oestra™ by Inner Balance is Redefining Hormone Therapy — And New Data Shows It’s Working",
    },
];
